exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.padding-round[data-v-1d97cda2] {\n    padding: 0 25px 0 25px;\n}\n", ""]);

// exports
